enum JoinGatheringError {
  IncorrectPassword = 'IncorrectPassword',
  TooManyPasswordAttempts = 'TooManyPasswordAttempts'
}
export default JoinGatheringError
